module.exports = __webpack_public_path__ + "img/glotLogo.87f3c5c9.svg";